import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import TemplateParameterizationsAPI from '../../api/templateParameterizations';

export const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
    isFetchingByInbox: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getParameterizations(_state) {
    return _state.records;
  },
  getParameterization(_state) {
    return Object.values(_state.records).length ? _state.records : null;
  },
  getMeta(_state) {
    return _state.meta;
  }
};

export const actions = {
  get: async ({ commit }, params) => {
    commit(types.SET_PARAMETERIZATION_UI_FLAG, { isFetching: true });
    commit(types.SET_META, {});

    try {
      const { page, sortAttr, limit, inboxId } = params;
      const response = await TemplateParameterizationsAPI.get(page, sortAttr, limit, inboxId);

      commit(types.SET_PARAMETERIZATIONS, response.data.payload);
      commit(types.SET_META, response.data.meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_PARAMETERIZATION_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_PARAMETERIZATION_UI_FLAG, { isCreating: true });

    try {
      const response = await TemplateParameterizationsAPI.create(data);

      commit(types.ADD_PARAMETERIZATION, response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_PARAMETERIZATION_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, data }) => {
    commit(types.SET_PARAMETERIZATION_UI_FLAG, { isUpdating: true });

    try {
      const response = await TemplateParameterizationsAPI.update(id, data);

      commit(types.EDIT_PARAMETERIZATION, response.data);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_PARAMETERIZATION_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_PARAMETERIZATION_UI_FLAG, { isDeleting: true });

    try {
      await TemplateParameterizationsAPI.delete(id);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_PARAMETERIZATION_UI_FLAG, { isDeleting: false });
    }
  },
  search: async ({ commit }, id) => {
    commit(types.SET_PARAMETERIZATION_UI_FLAG, { isFetching: true });

    try {
      const response = await TemplateParameterizationsAPI.search(id);

      commit(types.SET_PARAMETERIZATIONS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_PARAMETERIZATION_UI_FLAG, { isFetching: false });
    }
  },
  getAllByInbox: async ({ commit }, { inboxId, limit = 1000 } = {}) => {
    if (!inboxId) {
      return [];
    }

    commit(types.SET_PARAMETERIZATION_UI_FLAG, { isFetchingByInbox: true });

    try {
      const response = await TemplateParameterizationsAPI.get(1, 'id', limit, inboxId);
      return response?.data?.payload || [];
    } catch (error) {
      return [];
    } finally {
      commit(types.SET_PARAMETERIZATION_UI_FLAG, { isFetchingByInbox: false });
    }
  },
};

export const mutations = {
  [types.SET_PARAMETERIZATION_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_META](_state, data) {
    _state.meta = data;
  },

  [types.ADD_PARAMETERIZATION]: MutationHelpers.create,
  [types.EDIT_PARAMETERIZATION]: MutationHelpers.update,
  [types.SET_PARAMETERIZATIONS]: MutationHelpers.set,
  [types.DELETE_PARAMETERIZATION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
